import React from 'react';
import './style.scss';


const Footer = () => {

    return  (
        <section className="footer" id='footer'>
            <div className="container">
                <p>Develop by: <a href='https://github.com/RyanSantosRibeiro'>Ryan Santos</a></p>
            </div>
        </section>
    )
}

export default Footer;